import React from 'react'; 

const travellerInner = (props) => (
    <div className={`u-flex justify-content-between u-borderRadius4`}>{props.children}</div>
);

export default travellerInner;


// WEBPACK FOOTER //
// ./src/components/Travellers/TravellerInner/TravellerInner.js